import { RecoverStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { FrontendStepType, PartialWithRequiredType } from "../steps";
import { RecoverConfigPreview } from "./recover-config-preview";

export const recoverStepType: FrontendStepType<
  PartialWithRequiredType<RecoverStep>
> = {
  valid: (state) => !!state.templateId,
  type: "custom",
  customInspector: (props) => <RecoverConfigPreview {...props} />,
};
